const viewType = Object.freeze({
  Table: "Table",
  ListView: "ListView",
});

export default viewType;
